import Customer, { CustomerExtended, CustomersPagination } from 'data/Customer';
import { get,put } from 'lib/API';

export const loadCustomers = async (
  [size, page, offset, vendorId, searchTerm, businessUnitId]: any[],
  { token }: any
): Promise<CustomersPagination> => {
  return await get('v1/customers', token, { size, page, offset, vendorId, searchTerm, businessUnitId });
};

export const loadCustomer = async ({
  customerId,
  token,
}: any): Promise<Customer> => {
  return await get(`v1/customers/${customerId}`, token);
};

export const loadCompanyCustomers = async ({
  companyId,
  token,
}: any): Promise<Customer[]> => {
  return await get(`v1/customers/companyCustomers/${companyId}`, token);
};

export const loadCompanyCustomersDefer = async (
  [companyId]: any,
  { token }: any
): Promise<CustomerExtended[]> => {
  return await get(`v1/customers/companyCustomers/${companyId}`, token);
};

export const loadAffiliateCompanyCustomers = async (
  [companyId, brandCode]: any,
  { token }: any
): Promise<CustomerExtended[]> => {
  return await get(`v1/customers/affiliateCustomers/${companyId}`, token, { brandCode });
};

export const loadActiveAffiliateConsignment = async (
  [customerId, businessUnitId]: any[],
  { token }: any
): Promise<{ hasActiveAffiliateConsignment: boolean; consignmentId?: string; orderId?: string }> => {
  return await get(`v1/customers/${customerId}/active-affiliate-consignment`, token, { businessUnitId });
};

export const updateTaxExempted = async (
  [customerId, isTaxExempted]: any[],
  { token }: any
): Promise<any> => {
  return await put(`v1/customers/${customerId}`, token, {
    taxExempted: isTaxExempted
   });
};
